import { OrderCalculationView, OrderCalculationViewFields } from "../types/purchaseOrder/Order";
import {
    AppliedCouponDiscount,
    AppliedCouponDiscountFields,
} from "../types/purchaseOrder/couponTypes";

export interface PurchaseTrackingItem {
    price: number;
    quantity: number;
}

/**
 * Calcula el `value` a mandarle a Meta Pixel Purchase, replicando la misma
 * prioridad que usa `usePriceCalculator` para el total que ve el usuario:
 * 1. Si el backend calculó la orden (cupón aplicado con recálculo del lado
 *    del servidor), usa ese total tal cual.
 * 2. Si sólo hay un descuento de cupón aplicado localmente, usa el total con
 *    descuento + el envío.
 * 3. Si no hay cupón, es el subtotal del carrito + el envío.
 */
export function computeOrderTotalForPurchaseTracking(params: {
    calculationData?: OrderCalculationView | null;
    appliedDiscount?: AppliedCouponDiscount | null;
    shippingCost?: number | null;
    cartItems: PurchaseTrackingItem[];
}): number {
    const { calculationData, appliedDiscount, shippingCost, cartItems } = params;

    if (calculationData) {
        return calculationData[OrderCalculationViewFields.Total];
    }

    if (appliedDiscount) {
        return appliedDiscount[AppliedCouponDiscountFields.DiscountTotal] + (shippingCost ?? 0);
    }

    const subtotal = cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
    return subtotal + (shippingCost ?? 0);
}
